<template>
    <section class="font-poppins">
        <div class="flex justify-between">
            <div class="w-2/3 md:w-full p-2">
                <div class="flex justify-between mt-8 ">
                    <router-link to="/"><img class="md:w-1/2 w-4/5 pl-3"  src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1634105033/carrygoWebAssets/carrygo_logo_vrdtw8.svg" alt="logo"></router-link>
                    <p class="mr-10 text-blue-600 text-2xl md:text-sm">4/5</p>
                </div>

                <div class="flex justify-center">
                    <div>
                        <div class="text-4xl mt-10 flex justify-content-center">
                            <h2 class="text-blue-600 font-semibold md:text-lg" style="color:rgb(18,84,179)">Sign Up as a DSP</h2>
                        </div>
                        <div class="w-4/5  md:w-full">
                            <div class="mt-8 font-semibold">
                                <p>Documents</p>
                                <p class="mt-1 font-medium">upload only pdf, jpg, jpeg or png</p>
                            </div>
                            <div class="mt-5">
                                <form @submit.prevent="submitDetails" enctype="multipart/form-data">
                                    <div>
                                        <div>
                                            <label for="carrierMode" class=" font-bold">CG Carrier Mode</label><br>
                                            <select class="bg-gray-100 border w-full p-1 rounded-lg" name="carrierMode" id="carrierMode" @change="selectedCarrier($event)">
                                                <option selected value="" disabled>Select Carrier</option>
                                                <option value="Dispatch">Dispatch</option>
                                                <option value="CabHailing">Cab Hailing</option>
                                                <option value="Haulage">Haulage</option>
                                            </select>
                                            <p v-if="carrierValidity === 'invalid'" class=" text-xs text-red-500">this field must not be empty</p>

                                        </div>
                                    </div>

                                    <div class="mt-4">
                                        <label for="selectedIdCard" class=" font-bold"> ID Card Type</label><br>
                                        <select class="bg-gray-100 border w-full p-1 rounded-lg" name="selectedIdCard" id="selectedIdCard" v-model="selectedIdCard">
                                            <option value="" disabled>Select ID Card Type</option>
                                            <option value="Voters Card">Voters card</option>
                                            <option value="ID Card">National ID Card</option>
                                            <option value="Reg. Company Card">Reg. Company Card</option>
                                        </select>
                                        <p v-if="selectedIdCardValidity === 'invalid'" class=" text-xs text-red-500">this field must not be empty</p>

                                        <div>
                                            <input style="display:none" type="file" name="idCard" id="idCard" @change="onIdCard" ref="idCardUpload">
                                            <p class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" @click="$refs.idCardUpload.click()">--upload file-- {{this.idCardName}} </p>
                                            <p v-if="idCardValidity === 'invalid'" class=" text-xs text-red-500">please upload a file</p>
                                            <p v-if="idFileError" class=" text-xs text-red-500">{{idFileError}}</p>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="flex mt-5 text-sm">
                                            <input  type="checkbox" class="mt-2 mr-4" name="t&c" id="t&c" v-model="checkbox">
                                            <p>By creating an account, you are agreeing to our
                                                <a @click="showPolicy" class="text-blue-500 cursor-pointer">Terms of service</a> and <a @click="showPolicy" class="text-blue-500 cursor-pointer">Privacy policy</a>
                                            </p>
                                        </div>
                                        <p v-if="checkValidity === 'invalid'" class=" text-xs text-red-500">accept T&C to continue</p>
                                    </div>
                                    <p class="text-red-500 text-sm">{{error}}</p>
                                    <div class="mt-10 flex">
                                        <button class="w-full text-white rounded p-1" style="background-color:rgb(18,84,179)" >Proceed</button>
                                        <p v-if="isLoading" class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 "></p>
                                    </div>
                                </form>                              
                            </div>
                        </div>
                        
                    </div>
                    
                </div>
                
            </div>

            <div class="image w-1/3 md:hidden">

            </div>
        </div>

        <div class="lg:hidden mt-16">
            <the-footer/>
        </div>
        <div>
            <TermsPolicyModal
            v-show="termsPolicy"
            @close="closeModal"
            />
        </div>
    </section>
</template>

<script>
import TermsPolicyModal from '../TermsPolicyModal.vue';
import axios from 'axios';
import {baseUrl} from '../../../../Config';
const url = baseUrl;
export default {
    components:{TermsPolicyModal},

    data() {
        return {
            carrier: '',
            idCard: null,
            idCardName: "",
            selectedIdCard: "",
            checkbox: '',
            vehicleReceipt: null,
            vehicleReceiptName: null,
            carrierValidity: '',
           
            checkValidity: '',
            idCardValidity: '',
            selectedIdCardValidity:"",
            isLoading: false,
            termsPolicy: "",
            error: "",
            registration: "",
            idFileError: ""
        }
    },

    mounted() {
        this.networkError();
    },

    methods: {
        showPolicy() {
            this.termsPolicy = true;
        },
        closeModal() {
            this.termsPolicy = false;
        },
        selectedCarrier(event) {
            this.carrier = event.target.value; 
        },
        
        onIdCard(event) {
            this.idCard = event.target.files[0]
            this.idCardName = event.target.files[0].name
            if(!['image/png','image/jpeg','image/jpg', "application/pdf"].includes(event.target.files[0]['type'])){
                this.idFileError = "File type must only be png, jpeg, jpg, pdf."
            }else if(event.target.files[0]['size'] > 5000000){
                this.idFileError = "File must be less than 5MB"
            }else {
                setTimeout(() => {
                    this.idFileError = "";
                }, 1000);
            }
        },

        submitDetails() {
            this.networkError();
            this.$store.commit("carrier", this.carrier);
            if (!this.carrier) {
                this.carrierValidity = 'invalid';
                 setTimeout(() => {
                    this.carrierValidity = "";
                }, 3000);
            } else if (!this.selectedIdCard) {
                this.selectedIdCardValidity = 'invalid';
                 setTimeout(() => {
                    this.selectedIdCardValidity = "";
                }, 3000);
            }else if(!this.idCard) {
                this.idCardValidity = 'invalid'
                 setTimeout(() => {
                    this.idCardValidity = "";
                }, 3000);
            }else if (!this.checkbox) {
                this.checkValidity = 'invalid';
                 setTimeout(() => {
                    this.checkValidity = "";
                }, 3000);
            } else if(!this.idFileError){
                if(this.carrier === 'CabHailing' ) {
                    this.registration = "completed"
                }
                this.isLoading = true
                let data = new FormData();
                data.append('email', localStorage.getItem("dsoEmail"));
                data.append('carrierMode', this.carrier);
                data.append('selectedIdCard', this.selectedIdCard);
                data.append('idCard', this.idCard);
                data.append('registration', this.registration);
                axios({
                    method: 'PUT',
                    url: `${url}/v1/web/dsos/update`,
                    headers: {
                        'Content-type': 'application/json',
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                    data:data
                })
                .then((response) => {
                    response.json;
                    this.$store.commit("setAuthentication", true)  ;          
                    this.isLoading = false;
                    switch (this.carrier) {
                        case "Dispatch":
                            this.$router.push('/dso-step4-registration');
                            break;
                        case "Haulage":
                            this.$router.push('/dso-step4-registration');
                            break;
                    
                        default:
                            localStorage.removeItem('dsoEmail');
                            localStorage.removeItem('dsoPhone');
                            this.$router.push('/success')
                            break;
                    }
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                     setTimeout(() => {
                    this.error = "";
                }, 3000);
                    this.isLoading = false;
                });
            }
        },
        networkError() {
        if(!navigator.onLine) {
            this.$router.push('/network-error')
        } 
    }
    }
}
</script>

<style scoped>
.image {
    background-image: url("../Image/sea.png");
    background-repeat: no-repeat;
}
</style>
